
import { useEffect, useState, useContext } from "react";
import { FiArrowLeft, FiMenu, FiSettings } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";
import classNames from "utilities/ClassNames";
import setBodyColor from "test";
import { SideMenu, DateTime, UserMenu, Info, BorderGradient } from "processhub-components-lib";
import ProgressMonitoringLogo from "components/shared/ProgressMonitoringLogo";
import useScreen from "hooks/useScreen";
import { TfiAgenda } from "react-icons/tfi";
import { ReactComponent as GanttChart } from "assets/ganttChart.svg";
import { ReactComponent as TimelineLogo } from "assets/timeline.svg";
import { ReactComponent as MapIcon } from "assets/mapIcon.svg";
import { ModalContext } from "hooks/ModalProvider";
import HeaderMenu from "./HeaderMenu";
import { ReactComponent as HealthsensorIcon } from "assets/healthsensorIcon.svg";
import useUnity from "hooks/UseUnity";
import allHooks from "hooks";
import { navLinks } from "../config/navLinksConfig";
import { profileConfig } from "../config/userMenuConfig";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import OverallProgress from "components/OverallProgress";
import LocationsMenu from "./LocationsMenu";
import { motion } from 'framer-motion';
import { AiOutlineLeft } from "react-icons/ai";

export default function Header() {
  const { modalType, setModalType } = useContext(ModalContext);
  const { pathname } = useLocation();
  const [showSideMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();

  const [ganttShown, setGanttShown] = useState(false);
  const [reportShown, setReportShown] = useState(false);
  const [settingsShown, setSettingsShown] = useState(false);
  const [mapShown, setMapShown] = useState(false);
  const linkTarget = "_self";
  const { isScaled } = useScreen();
  const { TimelineShown, setTimelineShown } = useUnity();
  const menus = [
    {
      key: "3dplant",
      name: "3D Plant",
      path: "/3d-dashboard",
      islink: true,
      target: linkTarget,
      adminView: false,
    },
    {
      key: "dashboard",
      name: "Dashboard",
      path: "/dashboard",
      islink: true,
      target: linkTarget,
      adminView: false,
    },
  ];
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const auth = useAuth();
  const logout = async () => auth.signoutRedirect();

  useEffect(() => {
    if (window.vuplex) {
      if (showSideMenu) {
        const message = JSON.stringify({ object: "__S:ReactInputBlocker__", type: "ReactInputBlocker", method: "SetBlockState", arguments: [1] });
        window.vuplex.postMessage(message);
      }
      if (!showSideMenu) {
        const message = JSON.stringify({ object: "__S:ReactInputBlocker__", type: "ReactInputBlocker", method: "SetBlockState", arguments: [0] });
        window.vuplex.postMessage(message);
      }
    }
  }, [showSideMenu]);

  useEffect(() => {
    if (modalType === 'report') {
      setReportShown(true);
      setSettingsShown(false);
      setGanttShown(false);
      setMapShown(false);
    }
    if (modalType === 'settings') {
      setSettingsShown(true);
      setReportShown(false);
      setGanttShown(false);
      setMapShown(false);
    }
    if (modalType === 'gantt') {
      setGanttShown(true);
      setReportShown(false);
      setSettingsShown(false);
      setMapShown(false);
    }
    if (modalType === 'map') {
      setMapShown(true);
      setReportShown(false);
      setSettingsShown(false);
      setGanttShown(false);
    }
    if (modalType === '') {
      setReportShown(false);
      setSettingsShown(false);
      setGanttShown(false);
      setMapShown(false);
    }
  }, [modalType]);

  useEffect(() => {
    if (pathname === "/3d-dashboard" && window.vuplex) {
      setTimeout(() => {
        setTimelineShown(true);
      }, 100);
    }
  }, [pathname]);

  if (window.vuplex && pathname === "/3d-dashboard") {
    setBodyColor({ color: "rgb(0,0,0,0)" });
  } else {
    setBodyColor({ color: "rgb(57,57,57,1)" });
  }

  const buttonsConfig = [
    {
      name: 'Timeline',
      shown: TimelineShown,
      type: 'component',
      onClick: () => window.vuplex && pathname === "/3d-dashboard" && setTimelineShown((prev: any) => !prev),
      Icon: TimelineLogo,
      activeClass: "headerIconActive",
      inactiveClass: "headerIconInactive"
    },
    {
      name: 'Gantt Chart',
      shown: ganttShown,
      type: 'component',
      onClick: () => setModalType('gantt'),
      Icon: GanttChart,
      activeClass: "headerIconActive",
      inactiveClass: "headerIconInactive"
    },
    {
      name: 'Report',
      shown: reportShown,
      type: 'icon',
      onClick: () => setModalType('report'),
      Icon: TfiAgenda,
      activeClass: "text-blue",
      inactiveClass: "hover:text-green"
    },
    {
      name: 'Map',
      shown: mapShown,
      type: 'component',
      onClick: () => setModalType('map'),
      Icon: MapIcon,
      activeClass: "headerIconActive",
      inactiveClass: "headerIconInactive"
    },
    {
      name: 'Settings',
      shown: settingsShown,
      type: 'icon',
      onClick: () => setModalType('settings'),
      Icon: FiSettings,
      activeClass: "text-blue",
      inactiveClass: "hover:text-green"
    },
  ];

  return (
    <div className="w-full bg-dark relative z-40">
      <div
        className={classNames(
          "lg:h-12 xl-2xl:h-14 2xl:h-16",
          "mx-auto flex items-center px-3"
        )}
      >
        <div className={classNames(isScaled ? 'gap-3' : 'gap-2', "relative flex items-center w-full")}>
          <div
            onClick={() => setShowMenu(!showSideMenu)}
            className="cursor-pointer duration-300 z-50 "
          >
            {!showSideMenu && <FiMenu size={"40"} className="lg:w-[80%] xl-2xl:w-[90%] 2xl:w-full" />}
            {showSideMenu && <FiArrowLeft size={"40"} className="lg:w-[80%] xl-2xl:w-[90%] 2xl:w-full" />}
          </div>
          <Link to="/" className="z-50">
            <ProgressMonitoringLogo variant="regular" />
          </Link>
          <div className="w-full flex items-center">
            <div className="flex ml-4 gap-4">
              {menus.map((page) => {
                return (
                  <div
                    key={page.name}
                    className={classNames(page.key === "3dplant" && pathname === "/3d-dashboard" ? "hover:rotate-icon" : "", "relative")} // Add a class for hover state
                    onMouseEnter={page.key === "3dplant" ? () => setIsMenuVisible(true) : undefined}
                    onMouseLeave={page.key === "3dplant" ? () => setTimeout(() => setIsMenuVisible(false), 200) : undefined}
                  >
                    <Link target={page.target} to={page.path}>
                      <>
                        <div className={classNames("w-full", "rounded-lg bg-gradient-to-r from-green to-blue items-center justify-center relative")}>
                          <button className={classNames("h-[2.40rem] w-40 text-xl lg:h-[1.95rem] 2xl:h-[2.40rem] lg:w-32 2xl:w-48 lg:text-sm 2xl:text-lg", "text-center bg-gradient-to-r from-gray to-black rounded-lg hover:opacity-70 text-white mt-0.5 mb-0.5 ml-0.5 mr-0.5")}>
                            {page.name}
                          </button>
                          {page.key === "3dplant" && pathname === "/3d-dashboard" &&
                            <span className="absolute h-full flex items-center justify-center right-2 top-0">
                              <AiOutlineLeft className="icon" /> {/* Add a class to the icon */}
                            </span>
                          }
                        </div>
                      </>
                    </Link>
                    {
                      page.key === '3dplant' && pathname === "/3d-dashboard" &&
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={isMenuVisible ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                        transition={{ duration: 0.15, ease: "easeInOut" }}
                        className={classNames(isMenuVisible ? "" : "hidden", "overflow-hidden bg-white")}
                      >
                        <LocationsMenu />
                      </motion.div>
                    }
                  </div>
                );
              })}
            </div>
            <div className="w-full max-w-[275px] 2xl:max-w-[400px] px-2 mx-auto">
              <OverallProgress />
            </div>
          </div>
        </div>
        <HeaderMenu buttonsConfig={buttonsConfig} />
        <DateTime hooks={allHooks} />
        <div className="hover:text-green cursor-pointer w-min mr-6" onClick={() => navigate('/health')}>
          <HealthsensorIcon className={classNames("h-[23px] w-[23px] border-white rounded-full hover:text-green")} />
        </div>
        <Info hooks={allHooks} iconSize={isScaled ? 60 : 40} />
        <UserMenu hooks={allHooks} profileConfig={profileConfig} logout={logout} />
        <SideMenu
          closeMenu={() => setShowMenu(false)}
          showSideMenu={showSideMenu}
          navLinks={navLinks}
          hooks={allHooks}
        />
      </div>
    </div >
  );
}
